
import React, { useState } from "react";
import WebsiteLogo from "@/components/common/WebsiteLogo";
import { Button } from "@/components/ui/button";
import TermsOfUseModal from "@/components/welcome/components/TermsOfUseModal";

const TermsOfUsePage: React.FC = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center p-0">
      <div className="mt-8 mb-6">
        <WebsiteLogo width={180} />
      </div>
      
      <div className="w-full max-w-4xl px-4 mb-12 text-center">
        <h1 className="text-3xl font-bold mb-8">Terms of Use</h1>
        
        <Button 
          onClick={() => setIsTermsModalOpen(true)} 
          className="mt-4"
        >
          View Terms of Use
        </Button>
      </div>
      
      <TermsOfUseModal 
        isOpen={isTermsModalOpen} 
        onClose={() => setIsTermsModalOpen(false)} 
      />
    </div>
  );
};

export default TermsOfUsePage;
